import { HeaderBidderActiveActive } from '~/src/dash/api/console-api';
import { encodeForm } from '~/src/dash/api/resource';
import { createUrl, restPost } from '~/src/dash/api/rest';
import { ISessionState } from '~/src/dash/reducers/session-reducers';
import { IUserState } from '~/src/dash/reducers/user-reducers';
import { IMenuList } from '~/src/dash/types/menuList';
import { checkUserInfoMasked } from '~/src/dash/utils/roles';

export interface ISmallBiddersBySiteParams {
  publisher_id: string;
  site_ids: string;
}

export interface ISmallBidder {
  ID: string;
  Name: string;
  Active: number;
}

export interface ISmallBidders {
  HeaderBidders: ISmallBidder[];
}

export async function querySmallBidders(
  publisherID: string,
  query: ISmallBiddersBySiteParams,
): Promise<ISmallBidders> {
  const reqUrl = `${createUrl('/small_bidders', publisherID, 'v2')}`;
  const headers = { 'Content-Type': 'application/x-www-form-urlencoded' };
  const body = encodeForm(query, headers['Content-Type']);
  const response = await restPost<any>(reqUrl, query, { method: 'post', body, headers });
  return response.parsedBody;
}

export const getSmallBiddersList = (
  session: ISessionState,
  user: IUserState,
  siteIDs?: string, // example: '30, 11, 23'
): Promise<Record<string, IMenuList>> => {
  const publisherID = session.publisher.ID;
  return querySmallBidders(publisherID, {
    publisher_id: publisherID,
    site_ids: siteIDs || '',
  })
    .then(({ HeaderBidders }) => {
      const biddersList: IMenuList = {};
      HeaderBidders.forEach((hb) => {
        const ID = hb.ID;
        const title = checkUserInfoMasked(user.user) ? `demo_bidder_${ID}` : hb.Name;
        biddersList[ID] = {
          title,
          selected: false,
          ID,
          active: hb.Active === HeaderBidderActiveActive,
        };
      });
      return { Bidders: biddersList };
    })
    .catch((err) => {
      console.error(err);
      return { Bidders: {} };
    });
};
